import { render, staticRenderFns } from "./orderDetails.vue?vue&type=template&id=d1a2c9ec&scoped=true&"
import script from "./orderDetails.vue?vue&type=script&lang=js&"
export * from "./orderDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderDetails.vue?vue&type=style&index=0&id=d1a2c9ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a2c9ec",
  null
  
)

component.options.__file = "orderDetails.vue"
export default component.exports